/** Wire contracts shared by the API and the SPA. */
/**
 * Stable, machine-readable error codes. The SPA switches on these, never on
 * message text.
 */
export const ERROR_CODES = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
    EMAIL_ALREADY_REGISTERED: 'EMAIL_ALREADY_REGISTERED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_INVALID: 'TOKEN_INVALID',
    SESSION_REVOKED: 'SESSION_REVOKED',
    TWO_FACTOR_REQUIRED: 'TWO_FACTOR_REQUIRED',
    FORBIDDEN: 'FORBIDDEN',
    PERMISSION_DENIED: 'PERMISSION_DENIED',
    ORGANIZATION_REQUIRED: 'ORGANIZATION_REQUIRED',
    ORGANIZATION_ACCESS_DENIED: 'ORGANIZATION_ACCESS_DENIED',
    BRANCH_ACCESS_DENIED: 'BRANCH_ACCESS_DENIED',
    CROSS_TENANT_ACCESS: 'CROSS_TENANT_ACCESS',
    FEATURE_NOT_ENABLED: 'FEATURE_NOT_ENABLED',
    PLAN_LIMIT_REACHED: 'PLAN_LIMIT_REACHED',
    SUBSCRIPTION_INACTIVE: 'SUBSCRIPTION_INACTIVE',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    DUPLICATE_SKU: 'DUPLICATE_SKU',
    DUPLICATE_NUMBER: 'DUPLICATE_NUMBER',
    INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
    NEGATIVE_STOCK_NOT_ALLOWED: 'NEGATIVE_STOCK_NOT_ALLOWED',
    INVALID_STATE_TRANSITION: 'INVALID_STATE_TRANSITION',
    INVALID_UNIT_CONVERSION: 'INVALID_UNIT_CONVERSION',
    CREDIT_LIMIT_EXCEEDED: 'CREDIT_LIMIT_EXCEEDED',
    RATE_LIMITED: 'RATE_LIMITED',
    UNPROCESSABLE: 'UNPROCESSABLE',
    NOT_CONFIGURED: 'NOT_CONFIGURED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
export const HEADERS = {
    ORGANIZATION: 'x-organization-id',
    BRANCH: 'x-branch-id',
    REQUEST_ID: 'x-request-id',
    IDEMPOTENCY_KEY: 'idempotency-key',
    API_KEY: 'x-api-key',
};
export const API_PREFIX = 'api';
export const API_VERSION = 'v1';
//# sourceMappingURL=api.js.map